__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/6d184cbc73feed90f160cbb4b13c2a8928d686af5eecc8009a89b2b4/";